import { motion } from "framer-motion";

function FilterCard({ filter, selected, onClick, loading, isActive }) {
  const disabled = loading || !isActive;

  return (
    <motion.button
      type="button"
      aria-pressed={selected}
      aria-disabled={disabled}
      whileHover={disabled ? {} : { y: -2 }}
      whileTap={disabled ? {} : { scale: 0.98 }}
      onClick={disabled ? undefined : onClick}
      className={`w-[8.75rem] rounded-2xl border bg-white p-3 text-center shadow-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 sm:w-[10rem] ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:shadow-md"
      } ${
        selected
          ? "border-emerald-500 ring-2 ring-emerald-500"
          : "border-gray-200 hover:border-emerald-300"
      }`}
    >
      <div className="relative mx-auto h-20 w-20 sm:h-24 sm:w-24">
        <img
          src={filter.image}
          alt=""
          className={`h-full w-full object-contain transition-opacity ${
            loading ? "opacity-50" : !isActive ? "opacity-40 grayscale" : "opacity-100"
          }`}
        />
        {loading && (
          <div className="absolute inset-0 grid place-items-center">
            <div className="h-5 w-5 animate-spin rounded-full border-2 border-emerald-500 border-t-transparent" />
          </div>
        )}
      </div>

      <p
        className={`mt-2 text-sm font-semibold leading-snug ${
          loading ? "text-gray-500" : "text-gray-900"
        }`}
      >
        {filter.title}
      </p>

      {loading && <p className="mt-1 text-xs text-emerald-600">Loading...</p>}

      {!isActive && !loading && (
        <span className="mt-2 inline-flex items-center rounded-full border border-orange-200 bg-orange-50 px-2 py-0.5 text-[10px] font-medium text-orange-800">
          <span className="mr-1 h-1.5 w-1.5 rounded-full bg-orange-400" />
          Coming Soon
        </span>
      )}
    </motion.button>
  );
}

export default function PrimaryFilters({ filters, selectedKey, onSelect, loading }) {
  return (
    <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
      {filters.map((filter) => (
        <FilterCard
          key={filter.key}
          filter={filter}
          selected={selectedKey === filter.key}
          onClick={() => onSelect(filter.key)}
          loading={loading}
          isActive={filter.isActive}
        />
      ))}
    </div>
  );
}
